export default __webpack_public_path__ + "static/media/COSM110.b0ad4a17.mp3";